// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorInput_container__2iVtK","color":"ColorInput_color__dspbR","indicator":"ColorInput_indicator__2kEZU","opacity":"ColorInput_opacity__gRn0W"};